import { render, staticRenderFns } from "./simNotice.vue?vue&type=template&id=4d4536be&scoped=true&"
import script from "./simNotice.vue?vue&type=script&lang=js&"
export * from "./simNotice.vue?vue&type=script&lang=js&"
import style0 from "./simNotice.vue?vue&type=style&index=0&id=4d4536be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4536be",
  null
  
)

export default component.exports